import { render, staticRenderFns } from "./StudioProductMedia.vue?vue&type=template&id=8fe9fbf6&scoped=true&"
import script from "./StudioProductMedia.vue?vue&type=script&lang=js&"
export * from "./StudioProductMedia.vue?vue&type=script&lang=js&"
import style0 from "./StudioProductMedia.vue?vue&type=style&index=0&id=8fe9fbf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe9fbf6",
  null
  
)

export default component.exports